//---- Automatically generated, don't update this part ----

import Transform from "@ember-data/serializer/transform";
import DmpDocumentMetadata from "parog-web/models/dmp-document-metadata";

export default class DmpDocumentMetadatasTransform extends Transform {
  override deserialize(serialized) {
    if (serialized.length > 0) {
      return serialized.map(doc => new DmpDocumentMetadata(doc));
    }

    return null;
  }

  override serialize(deserialized: DmpDocumentMetadata[]) {
    return deserialized.map(doc => doc.toJson());
  }
  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/transform" {
  export default interface ModelRegistry {
    "dmp-document-metadatas": DmpDocumentMetadatasTransform;
  }
}
